import { Form, Input } from "antd";

export const BasicInput = ({
  className,
  name,
  label,
  hasFeedback,
  placeholder,
  rules = false,
  message = null,
}) => {
  return (
    <Form.Item
      className={className}
      name={name}
      label={label}
      hasFeedback={hasFeedback}
      rules={[
        { required: rules, message: message ? message : `${name} is required` },
      ]}
    >
        <Input
          className="bg-[#EEF0F2] w-44 h-10 border-[#EEF0F2] font-normal text-xs text-[#5B6268] rounded-lg"
          placeholder={placeholder}
        />
    </Form.Item>
  );
};
